enum QuotaType {
    USER_ACTIVE_TASK = 'user_active_task',
    USER_BACKLOG_TASK = 'user_backlog_task',
    USER_BRAND_PROFILE = 'user_brand_profile',
    USER_AI_IMG_PERIOD_TOKEN = 'user_ai_img_period_token',
    USER_AI_TASK_BRIEF_PERIOD_RUNS = 'user_ai_task_brief_period_runs',
    USER_SPACE_MEMBER_COUNT = 'user_space_member_count'
}

export default QuotaType;
